<template>
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <!-- Alert message -->
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>

    <!-- Header -->
    <header-component :headerTitle="headerText" />

    <!-- Image show popup -->
    <v-dialog v-model="dialogVisible" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <span class="headline">Images</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text>
          <v-row>
            <v-col v-for="(imageUrl, index) in item_images" :key="index" cols="4">
              <img :src="imageUrl" width="100%" contain @click="openImagePopupSingle(imageUrl)" class="img-rad-size" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imagePopup" persistent max-width="600">
      <v-card class="v-card-100">
        <v-card-title class="d-flex">
          <v-spacer></v-spacer>
          <v-btn icon @click="imagePopup = false;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-img :src="selectedImage" width="100%" style="border-radius:8px;" contain></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-repair" v-model="filterPopup" persistent max-width="1145px" >
        <v-card>
          <v-card-actions>
            <!-- <v-autocomplete v-model="return_type_search" outlined :items="return_types" item-title="original_code" item-value="id" label="Return Types" > </v-autocomplete> -->
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="return_type_search" label="Return Types" class="ma-2" variant="outlined" ></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="ra_location_search" label="Location" class="ma-2" variant="outlined" ></v-text-field>
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="ra_branch_search" label="Branch" class="ma-2" variant="outlined" ></v-text-field>
            <!-- <v-autocomplete v-model="region_search" variant="outlined" :items="regions" item-title="original_code" item-value="id" label="Region" > </v-autocomplete> -->
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="region_search" label="Region" class="ma-2" variant="outlined" ></v-text-field>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn size="small" class="text-none" variant="outlined" text color="primary" @click="closeFilterpopup">Cancel</v-btn>
            <v-btn size="small" class="text-none" variant="flat" color="primary" @click="fetchTableData">Apply Filter(S)</v-btn >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Popups for approval and rejection -->
    <v-row justify="center">
      <v-dialog v-model="approvePopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex align-center">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="approvePopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>
              <strong>{{ successmessage }}</strong>
            </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" @click="loadData" class="mb-3">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="rejectPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="rejectPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span>
              <strong>{{ selected.length }}. Sub Request Id successfully Rejected</strong>
            </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" @click="rejectPopup = false" class="mb-3" >Ok</v-btn >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Download Popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadPopup" persistent max-width="424px">
        <v-card class="v-card-100 pa-2">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="downloadPopup = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <span><strong>CSV file downloaded successfully !</strong> </span>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="flat" color="primary" class="mb-3">Ok</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- search -->
    <v-card-title style="padding: 28px;">
      <!-- Search fields -->
      <v-row>
        <v-col cols="3" sm="3">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search" style="max-width: 300px;" variant="outlined" v-on:keyup.enter="loadData('search_action')" ></v-text-field>
        </v-col>
        <v-spacer></v-spacer>
        <!-- Actions buttons -->
          <v-card-actions style="margin-bottom: 28px;">
            <v-menu offset-y v-if="!(currentUser.roles.includes('default_user'))">
              <template v-slot:activator="{ props }">
                <v-btn
                  color="primary"
                  variant="flat"
                  v-bind="props"
                  x-large
                  :disabled="selected.length == 0" class="text-none">
                  Approval Decision
                  <v-icon dark>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="approveDecision('Approve')">
                  <v-list-item-title>Approve</v-list-item-title>
                </v-list-item>
                <v-list-item @click="approveDecision('Reject')">
                  <v-list-item-title>Reject</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <!-- <v-btn class="ma-2" :color="disableActionBtns() ? 'secondry' : 'primary'" :disabled="disableActionBtns()" @click="downloadCsv">DOWNLOAD</v-btn>
            <v-btn class="ma-2" color="primary" @click="navigateToFileUpload()">UPLOAD</v-btn> -->
          </v-card-actions>
        <!-- Filter -->
        <v-col cols="2" sm="2" lg="2">
          <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly style="max-width: 150px; margin-bottom: 28px; min-height: 50px;" >
          <v-expansion-panel variant="outlined" @click="filterListOfButtons">
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
  
      </v-row>

    </v-card-title>

    <!-- Data Table -->
    <v-layout column>
      <v-col cols="12" style="overflow: auto;" class="p-0">
        <v-data-table hover
          density="compact"
          :search="search"
          v-model="selected"
          :items="table_data"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :loading="loading"
          fixed-header
          height="100%"
          :items-per-page="pageSize"
          loading-text="Loading Data... Please wait"
          return-object
          class="elevation-1">
          <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.key}`]="{ item }">
            <span v-if="header.key !== 'return_sub_request_id'">
              <span v-if="item[header.key] !== null && item[header.key] !== ''">
                {{ item[header.key] }}
              </span>
              <span v-else>
                <span>-</span>
              </span>
            </span>
            <span v-else>
              <a @click="subRequestDialog(item)" style="color: #1976d2; cursor: pointer;">
                <u>{{ item.return_sub_request_id }}</u>
              </a>
            </span>
          </template>
          <template #[`item.images`]="{ item }">
            <a @click="viewCustomerDeclarationImages(item)" v-if="item.images != ''">
              <span style="text-decoration: underline;color:#1976d2;">View</span>
            </a>
            <span v-else>-</span>
          </template>
          <template #bottom></template>
        </v-data-table>
      </v-col>
    </v-layout>

    <!-- pagination display -->
    <v-container fluid>
      <div>
        <v-row class="ml-2 pb-0">
          <v-col cols="3" sm="3" class="PaddingItemPerPage d-flex mt-3">
            <label class="" style="margin-top: -2px;">Rows Per Page</label>
            <v-select v-model="pageSize" :items="pageSizes" class="custom-pagination-ui" @update:modelValue="handlePageSizeChange"
            variant="outlined" style="width: 40px;margin-left: 120px;margin-top:-10px;position:absolute;"></v-select>
          </v-col>
          <span class="item-selected"> <span v-if="selected.length == 1">{{ selected.length }} Item Selected</span> <span
              v-if="selected.length > 1">{{ selected.length }} Items Selected</span> </span>
          <v-spacer></v-spacer>
          <span class="pt-3 mt-3 mr-5" v-if="this.totalCount > 0">Showing Results {{ (this.page - 1) * this.pageSize + 1 }}
            - {{ Math.min(this.page * this.pageSize, this.totalCount) }} of {{ this.totalCount }}</span>
          <v-col cols="2" sm="2" class="PaddingItemPerPage custom-column-ui">
            <v-pagination v-model="page" :length="totalPages" total-visible="7" class="custom-pagination-ui"
              @update:modelValue="handlePageChange" circle></v-pagination>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
export default {
  components: {
    HeaderComponent
  },
  data() {
    return {
      headerText: " D2C Return Approval",
      selected: [],
      search_tag: "",
      page: 1,
      totalPages: 1,
      totalCount : '',
      pageSize: 100,
      pageSizes: [100, 200, 500],
      row: "",
      table_data: [],
      isDisabled: true,
      enabled: false,
      filterPopup: false,
      vendor_id: "",
      return_types: [],
      return_type_search: [],
      ra_location_search: "",
      ra_branch_search: "",
      region_search: [],
      search: "",
      alert_message: "",
      alert_type: "info",
      alert: false,
      downloadPopup: false,
      decisionMenu: false,
      approvePopup: false,
      rejectPopup: false,
      regions: "",
      successmessage: "",
      currentUser: {},
      approvalList: [
        { name: "Approve" },
        { name: "Reject" },
        { name: "Not Decided" }
      ],
      loading: false,
      itemss: [
        {
          name: "Approve"
        }
      ],
      dialogVisible: false,
      item_images: [],
      imagePopup: false,
      selectedImage: '',
    };
  },

  created() {
    this.loadData();
    this.currentUser = this.$store.state.currentUser;
  },
  computed:{
    formatted_table_data(){
      return this.table_data.map((item) => {
        const formattedItem = { ...item };
        this.headers.forEach((header) => {
          if (header.text.includes("₹")) {
            formattedItem[header.value] = this.formatCurrency(item[header.value]);
          }
        });
        return formattedItem;
      });
    },
  },
  methods: {
    // show Alert messages
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.alertTimeOut();
    },
    formatCurrency(value) {
      return Number(value).toLocaleString('en-IN');
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },

    loadData(search_action) {
      this.selected = [];
      if (search_action) {
        this.request_type_search = "";
        this.ra_location_search = "";
        this.region_search = "";
        this.ra_branch_search = "";
      }
      this.page = 1;
      this.approvePopup = false;
      this.totalPages = 1;
      this.pageSize = 100;
      this.headers = [
        { title: "Sub-request", align: "start", sortable: false, key: "return_sub_request_id" },
        { title: "Ageings", key: "ageing" },
        { title: "Customer", key: "customer_name" },
        { title: "Location", key: "item_location" },
        { title: "Branch", key: "branch" },
        { title: "Region", key: "region" },
        { title: "Zone", key: "zone" },
        { title: "Validation", key: "policy" },
        { title: "Repairable", key: "repairable_status" },
        { title: "Repair Cost (₹)", key: "repair_cost" },
        { title: "Repair Cost (%)", key: "repair_cost_percent" },
        { title: "Customer Resolution Decision", key: "customer_resolution_decision" },
        {title: "Images", key: "images"},
        { title: "Item Decision", key: "item_decision" }
      ];
      this.fetchTableData();
    },

    // filter Dialog PopUP
    filterListOfButtons(ev) {
      this.search_tag = "";
      this.filterPopup = true;
      document.documentElement.style.setProperty(
        "--dialog-ypos",
        (
          this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40
        ).toString() + "px"
      );
    },

    // Apply Filters Function
    applyFilterFunc() {
      const params = new URLSearchParams();
      params.append("return_type", this.request_type_search);
      params.append("return_request_id", this.return_request_id_search);
    },

    // close filter popup and clear all the fields
    closeFilterpopup() {
      this.filterPopup = false;
      this.return_type_search = "";
      this.ra_location_search = "";
      this.region_search = "";
      this.ra_branch_search = "";
    },

    // fetch table data
    fetchTableData() {
      this.loading = true;
      const params = {
        search: this.search_tag,
        return_type: this.return_type_search,
        location: this.ra_location_search,
        branch: this.ra_branch_search,
        region: this.region_search,
        page: this.page,
        per_page: this.pageSize
      };
      this.$httpSecured
        .get(`/api/v1/warehouse/return_initiation/return_approvals`, {
          params: params
        })
        .then(response => {
          if (response.data) {
            this.table_data = response.data.return_items;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count;
            this.filterPopup = false;
            this.loading = false;
            this.closeFilterpopup()
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    searchData() {
      const params = new URLSearchParams();
      params.append("search", this.search_tag);
      params.append("page", this.page);
      params.append("per_page", this.pageSize);
    },

    subRequestDialog(item) {
      const return_id = item;
      this.$store.commit("setLotIds", {
        lotIds: return_id,
        inventoryId: "D2C Return Approval"
      });
      this.$router.push({ name: "sub_request_approval" });
    },
    disableActionBtns() {
      if (this.selected.length === 0) {
        return true;
      }

      const firstSelectedType = this.selected[0];

      for (const type of this.selected) {
        if (type !== firstSelectedType) {
          return true;
        }
      }

      return false;
    },
    viewCustomerDeclarationImages(item) {
      this.dialogVisible = true;
      this.item_images = item.images
    },
    openImagePopupSingle(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
    closeDialog(){
      this.dialogVisible = false;
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.fetchTableData();
    },
    handlePageChange(value) {
      this.page = value;
      this.fetchTableData();
    },
    downloadCsv() {
      this.downloadPopup = true;
    },
    approveDialog() {
      this.approvePopup = true;
    },
    rejectDialog() {
      this.rejectPopup = true;
    },
    navigateToFileUpload() {
      this.$store.commit("setLotIds", {
        lotIds: "d2c_return_approval",
        inventoryId: "D2C Return Approval"
      });
      this.$router.push({ name: "LotFileuploadComm" });
    },
    approveDecision(value) {
      this.number++;
      const itemId = this.selected.map(table_data => table_data.id);
      const params = {
        ids: itemId,
        action_type: value,
        is_bulk_approve: true
      };
      if(value === 'Approve'){
        if(this.selected.length > 0){
          const initialApprovalValues = [...new Set(this.selected.map(item => item.is_initial_request_approval))];
          this.$store.commit("setUnique", {
            set_unique: initialApprovalValues
          });

          if (initialApprovalValues.length > 1) {
            this.showAlert("error", "Selected request should be initailly or further level.");
            return;
          }
        }
        this.$store.commit("setLotIds", {
          lotIds: this.selected.length === 1 ? this.selected[0] : itemId,
          action: this.selected.length === 1 ? 'single_item_approve' : 'from_home_approve',
          inventoryId: this.headerText,        
        });
        this.$store.commit("setActiveTab", {
          active_tab: this.selected
        });
        this.$router.push({ name: "sub_request_approval" });
      }else{
        this.$httpSecured
        .post(
          "/api/v1/warehouse/return_initiation/return_approvals/bulk_approve",
          params
        )
        .then(response => {
          if (response.data) {
            this.approvePopup = true;
            this.successmessage = response.data.message;
            this.successpopup = true;
            this.number = 0;
          } else {
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", error.response.data.error);
          this.number = 0;
        });
      }
    }
  }
};
</script>
<style scoped>
.label-print {
  text-decoration: underline;
  color: #0357d0;
  cursor: pointer;
  box-shadow: none !important;
  padding: 0 !important;
  height: 0 !important;
}
.generate-label {
  color: #19b100;
}
.v-dialog__content:has(.filter-repair) {
  justify-content: right;
  align-items: baseline;
  top: 10.5rem;
}

.link-color {
  color: #0357d0;
  font-size: 14px;
  font-weight: 600;
}
.img-rad-size {
  width: 186px;
  height: 184px;
  border-radius: 8px;
}

.bg-color {
  background: #0357d0;
  color: #ffffff;
}
.v-label {
  position: relative !important;
  margin-top: 50px !important;
}

.disable-text-color {
  color: #9f9d9d;
}
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}
@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}
</style>
